import flow from 'lodash/flow';
import * as EXCLUSIONS_TYPES_JSON from '../assets/locales/en/grammar/grammar-types.json';
import * as PHRASAL_VERBS_JSON from '../assets/locales/en/grammar/phrasal-verbs.json';

// TODO: MBS-23305
const EXCLUSIONS_TYPES: { [key: string]: string[] } = (EXCLUSIONS_TYPES_JSON as any).default || EXCLUSIONS_TYPES_JSON;
const PHRASAL_VERBS: string[] = (PHRASAL_VERBS_JSON as any).default || PHRASAL_VERBS_JSON;

/*
 * union array of exclusions
 */
const ALL_EXCLUSIONS = Object.values(EXCLUSIONS_TYPES).flat();

/*
 * Pre-compile regular expressions for phrasal verbs (Performance optimization)
 * \b ensures that we only replace exact whole word matches
 */
const PHRASAL_VERB_REPLACERS = PHRASAL_VERBS.map((pv) => ({
  regex: new RegExp(`\\b${pv}\\b(?!-)`, 'ig'),
  replacement: pv
}));

/*
 * check to word by exclusions
 * @param word
 * @returns boolean
 */
const isExclusion = (word: string): boolean => ALL_EXCLUSIONS.includes(word);

/*
 * capitalize word
 * @param word
 * @returns
 */
export const capitalize = (word: string): string => word.charAt(0).toUpperCase() + word.slice(1);

/*
 * transform word case by rule
 * @param word
 * @param index
 * @param accum source words array
 * @returns
 */
const transformEnTitle = (word: string, index: number, accum: string[]): string => {
  const byPrev = index === 0 || accum[index - 1].endsWith(':');
  const isLast = accum.length - 1 === index;

  if (word.includes('-')) {
    return word
      .split('-')
      .map((part, partIndex) => {
        if (partIndex === 0) return capitalize(part);
        if (part.length > 4) return capitalize(part);

        return isExclusion(part) ? part : capitalize(part);
      })
      .join('-');
  }

  if (byPrev || isLast || word.length > 4) {
    return capitalize(word);
  }

  return isExclusion(word) ? word : capitalize(word);
};

/*
 * Capitalize title by rule MBS-A-165
 * @param value
 * @returns
 */
export const capitalizeEnTitle = (value: string): string => {
  const baseTitle = value.split(/\s/).map(transformEnTitle).join(' ');

  return PHRASAL_VERB_REPLACERS.reduce((acc, { regex, replacement }) => acc.replace(regex, replacement), baseTitle);
};

/*
 * Drop last char if is dot
 * @param value
 * @returns
 */
export const dropDot = (value: string): string => value.replace(/\.$/g, '');

/*
 * Formating title by current locale
 * @param value
 * @param lng
 * @returns
 */
export const formatTitle = (value: string, lng: string) => {
  switch (lng) {
    case 'en': {
      return flow(capitalizeEnTitle, dropDot)(value);
    }
    case 'any':
    default:
      return dropDot(value);
  }
};

/*
 * Token
 */
export const FORMAT_TOKEN = 'title';
